import React,{useEffect,useState} from 'react';
import './navbar.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {  logout } from '../../redux/reducers/authSlice';
import { snackbarContext } from './Snakbar';
import { startPayment } from './paymentpopup';
// import LiveToggle from './Toggle';
import CloseIcon from '@mui/icons-material/Close';

const Navbar = () => {
  const setStateSnackbarContext = React.useContext(snackbarContext);
   const [showUpgradeModal, setShowUpgradeModal] = useState(false); 
   const [paymentLoading, setPaymentLoading] = useState(false);
   const { user,loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
 const [timeLeft, setTimeLeft] = useState('');
  const logoutFunc = () => {
    dispatch(logout({ navigate, setStateSnackbarContext }));
  };

    useEffect(() => {
    if (user?.demoVersion && user?.demoExpiryTime) {
      const interval = setInterval(() => {
        const now = new Date();
        const expiry = new Date(user.demoExpiryTime);
        const diff = expiry - now;

        if (diff <= 0) {
          clearInterval(interval);
          setTimeLeft('Expired');
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [user]);



   const handleUpgradeClick = async () => {
      if (paymentLoading) return;

      setPaymentLoading(true);

      await startPayment(
    user?.userCode,
    navigate,
    setStateSnackbarContext,
    user?.isAdmin,
    () => setPaymentLoading(false) // callback
  );
  }

  return (
    <>
    <div className="container-fluid nav_bg">
    {/* navbar demo-navbar */}
      <nav className={` navbar-expand-lg navbar-light bg-light ${user && user.demoVersion?"navbar demo-navbar":"navbar normal-navbar"}`}>
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/">
            <img src={process.env.PUBLIC_URL + '/finallogo.png'} alt="" />
           {user && user.demoVersion ? <span className='trail-tag'> ( Trial ) </span>:""}
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav" 
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    isActive ? 'menu_active nav-link' : 'nav-link'
                  }
                  to="/"
                >
                  HOME
                </NavLink>
              </li>

              <li className="nav-item">
                {user && user.hasEnded ? (
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? 'menu_active nav-link' : 'nav-link'
                    }
                    to="/links"
                  >
                    Edit Page
                  </NavLink>
                ) : (
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? 'menu_active nav-link' : 'nav-link'
                    }
                    to="/events"
                  >
                    My Events
                  </NavLink>
                )}
              </li>
             

              <li className="nav-item">
              {user &&   <NavLink  className="nav-link" to={`/preview/${user?.userCode}`}>
                    PREVIEW
                  </NavLink>}
          
              </li>

              <li className="nav-item">
                <button onClick={logoutFunc} className="logout-button">
                  Logout
                </button> 
              </li>
            </ul>
          </div>
        </div>
              {/* <div className='live-toggle-switch' >
      <span >Invite Links is:</span>
      <LiveToggle checked={user && user.isLive}  onChange={handleToggle}  disabled={loading}/>
    </div> */}
      </nav> 
      {user && user.demoVersion ? <div className='demo-subnavbar'>
 {user && user.demoVersion ? <span className='trial-count'> Trial Ends in :{timeLeft} </span>:""}  
{user && user.demoVersion ? <span className='upgrade-text'> <span style={{color:"blue",fontWeight:"bold",textDecoration:"underline",cursor:"pointer"}}  onClick={()=>setShowUpgradeModal(true)}  >Upgrade now</span> to keep your invite active </span>:""} 
    </div>:""} 
    </div>

    {showUpgradeModal && (
  <div className="modal-overlay">
    <div className="modal-container">

      {/* Close */}
      <button
        className="modal-close"
        onClick={() => setShowUpgradeModal(false)}
      >
        <CloseIcon className="close-icon" />
      </button>

      {/* Heading */}
      <h2 className="modal-title">
        Upgrade Your Invitation
      </h2>

      {/* Description */}
      <p className="modal-desc">
        Get the complete invitation with all trial restrictions removed.
      </p>

      {/* Benefits */}
      <div className="upgrade-modal-descp">

        {/* Invite Validity */}
        <div className="upgrade-point">
          <span className="benefit-icon">📅</span>

          <p>
            <strong>Invite Validity</strong>

            <span>
              Active from upgrade until 20 days after your wedding date
            </span>
          </p>
        </div>

        {/* Payment */}
        <div className="upgrade-point">
          <span className="benefit-icon">💳</span>

          <p>
            <strong>One-time payment</strong>

            <span>
              ₹999 · No subscription
            </span>
          </p>
        </div>

        {/* Everything Unlocked */}
        <div className="upgrade-point">
          <span className="benefit-icon">✨</span>

          <p>
            <strong>Everything unlocked</strong>

            <span>
              All trial watermarks, limits & restrictions removed
            </span>
          </p>
        </div>

      </div>

      {/* Upgrade Button */}
      <button
        className={`final-upgrade-btn ${
          paymentLoading ? "disabled" : ""
        }`}
        onClick={handleUpgradeClick}
        disabled={paymentLoading}
      >
        {paymentLoading
          ? "Opening payment…"
          : "Upgrade for ₹999 →"}
      </button>

    </div>
  </div>
)}
    </>  
  );
};

export default Navbar;
